/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkRcptSync04Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkRcptSync04ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const stkRcptSync04FetchStkRcptSync04Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkRcptSync04FetchStkRcptSync04Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkRcptSync04AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkRcptSync04RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkRcptSync04SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkRcptSync04SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const stkRcptSync04SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkRcptSync04Types.STK_RCPT_SYNC04_RESET_TIMESTAMP]: stkRcptSync04ResetTimestamp,
  [StkRcptSync04Types.STK_RCPT_SYNC04_FETCH_STK_RCPT_SYNC04_LOADING]: stkRcptSync04FetchStkRcptSync04Loading,
  [StkRcptSync04Types.STK_RCPT_SYNC04_FETCH_STK_RCPT_SYNC04_SUCCESS]: stkRcptSync04FetchStkRcptSync04Success,
  [StkRcptSync04Types.STK_RCPT_SYNC04_ADD_SELECTED_DOCUMENTS]: stkRcptSync04AddSelectedDocuments,
  [StkRcptSync04Types.STK_RCPT_SYNC04_REMOVE_SELECTED_DOCUMENTS]: stkRcptSync04RemoveSelectedDocuments,
  [StkRcptSync04Types.STK_RCPT_SYNC04_SET_WORKSPACE_VISIBLE]: stkRcptSync04SetWorkspaceVisible,
  [StkRcptSync04Types.STK_RCPT_SYNC04_SYNC_LOADING]: stkRcptSync04SyncLoading,
  [StkRcptSync04Types.STK_RCPT_SYNC04_SYNC_NOW_SUCCESS]: stkRcptSync04SyncNowSuccess
});
